import React from "react";
import { Button } from "@material-ui/core";
import iconError from "./icon404.png"
import "./ErrorPage.css"

export function ErrorPage1() {
  return (
    <div className="d-flex  flex-root justify-content-center row p-md-10 p-5">
      <div className="container d-flex justify-content-center mt-5 align-items-center">
        <div className="d-flex justify-content-center align-items-center  p-5 py-15 row bg-white px-10" style={{ boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px" }}>
          <img src={iconError} id="iconError" alt="success"></img>
          <div className="col-12 d-flex justify-content-center mt-5 text-center not-found"><p className="mb-0">صفحه موردنظر یافت نشد</p></div>
          <div className="col-12 d-flex justify-content-center">
            <div className="text-center size1">برای پیدا کردن مسیر درست میتوانید به صفحه اصلی سایت مراجعه نمایید.</div>
          </div>
          <div className="col-12 d-flex justify-content-center mt-8">
            <Button
              className="col-md-4 col-sm-6 col-11 h-100"
              style={{
                backgroundColor: "#6dd06d",
                border: "0.5px solid white",
                borderRadius: "13px",
              }}
            >
              <a className="mx-auto my-auto text-white size1" href="http://ebus.ir">
                بازگشت به صفحه اصلی
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
